import styled from "styled-components";

export const PreviewContainer = styled.article`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const PreviewImage = styled.img`
  width: 100%;
  max-height: 420px;
  object-fit: cover;
  border-radius: 10px;
`;

export const PreviewTitle = styled.h1`
  font-size: 2rem;
  line-height: 1.2;
  word-break: break-word;
  color: ${(props) => props.theme["gray-300"]};
`;

export const PreviewMeta = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  font-size: 0.875rem;
  color: ${(props) => props.theme["gray-100"]};

  span {
    text-transform: capitalize;
  }
`;

export const PreviewBlock = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  h3 {
    font-size: 1.25rem;
    color: ${(props) => props.theme["purple-500"]};
  }

  p {
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.6;
    color: ${(props) => props.theme["gray-300"]};
  }

  img {
    width: 100%;
    max-height: 360px;
    object-fit: cover;
    border-radius: 8px;
  }
`;
